
import { signal } from '../../../../../services/SignalsService'
import SymbolSkin from './SymbolSkin'

export default class DragonSymbolSkin extends SymbolSkin {

  constructor(id, settings) {
    super(id, settings)
  }
  createSymbol(id) {
    super.createSymbol(id)
  }

  playCascadeDrop(){
    if(this._spine.state.hasAnimation('stop')) {
      this.swapSpine(true)
      signal.dispatch('SOUND:CASCADE:Scatter:Wild')
      this._spine.playCallBack( 'stop', false, () => {})
    }

  }

}
